import script from "./decisionNode.vue?vue&type=script&lang=ts&setup=true"
export * from "./decisionNode.vue?vue&type=script&lang=ts&setup=true"

import "./decisionNode.vue?vue&type=style&index=0&id=9612661c&lang=css"

const __exports__ = script;

export default __exports__